import React, { forwardRef } from "react";

import { UploadIcon } from "@eisox/icons";

import * as Control from "../Control/control.component";
import { cn } from "../index";

export interface FileInputProps extends React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
> {
  onAddFile?: (files: File[]) => void;
  error?: boolean;
}

const FileInput = forwardRef<HTMLInputElement, FileInputProps>(
  ({ onAddFile, className, placeholder, error, ...props }, ref) => {
    const handleDrop = (e: React.DragEvent<HTMLLabelElement>) => {
      e.preventDefault();
      const droppedFiles = e.dataTransfer.files;
      if (droppedFiles.length > 0) {
        onAddFile?.(Array.from(droppedFiles));
      }
    };

    return (
      <Control.Root
        asChild
        error={error}
        rounded
        className={cn("gap-2.5 font-normal cursor-pointer text-primary-dark-gray", className)}
      >
        <label onDrop={handleDrop} onDragOver={e => e.preventDefault()}>
          {placeholder}
          <UploadIcon className="ml-auto" />
          <input ref={ref} {...props} type="file" className="hidden" />
        </label>
      </Control.Root>
    );
  },
);

FileInput.displayName = "FileInput";

export { FileInput };
